import React, { useState } from "react";
import "../styles/Steps.css";
const Steps = () => {
  const [steps] = useState([
    {
      id: 1,
      title: "GET A QUOTE",
    },
    {
      id: 2,
      title: "GET A POLICY PLAN",
    },
    {
      id: 3,
      title: "CONTRIBUTE TO POLICY",
    },
    {
      id: 4,
      title: "MAKE A CLAIM",
    },
  ]);
  return (
    <>
      <section className="steps">
        <div className="container">
          <div className="row ">
            {steps.map((step) => {
              if (step.id === 4) {
				return(<div className="col-md-3 ">
				<div className="steps__content no-border text-center ">
				  <h3>{step.title}</h3>
				</div>
			  </div>);
              } else {
                return(<div className="col-md-3 ">
                  <div className="steps__content text-center">
                    <h3>{step.title}</h3>
                  </div>
                </div>);
              }
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Steps;
